import { Suspense, useState } from "react";
import PageErrorBoundary from "../PageErrorBoundary";
import ConditionalDisplay from "../ConditionalDisplay";
import LoadingModal from "../LoadingModal";

const PageWrapper = ({ render, display, unmount, currentPage, children }) => {
  const [error, setError] = useState(false);

  return (
    <ConditionalDisplay
      render={render}
      display={display}
      unmount={unmount || error}
    >
      <Suspense fallback={<LoadingModal width={6} />}>
        <PageErrorBoundary currentPage={currentPage} setError={setError}>
          {children}
        </PageErrorBoundary>
      </Suspense>
    </ConditionalDisplay>
  );
};

export default PageWrapper;
